import { render, staticRenderFns } from "./TableProductos_table.vue?vue&type=template&id=e35ccf4c&"
import script from "./TableProductos_table.vue?vue&type=script&lang=js&"
export * from "./TableProductos_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports